 <template>
  <!-- 异常列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div
      class="glo_btnList"
      ref="btnList"
    >
      <div class="glo_btnList_left">
        <el-button
          v-if="hasPermiss('admin:exception_bill:addException')"
          class="glo_btnItems glo_bgcMainColor"
          @click="addBtns"
        >新建异常</el-button>
        <el-button
          v-if="hasPermiss('admin:exception_bill:dutyException')"
          class="glo_btnItems"
          @click="ExceptionHeDing({})"
        >责任核定</el-button>
        <el-button
          v-if="hasPermiss('admin:exception_bill:claimPosting')"
          class="glo_btnItems"
          @click="claimPosting()"
        >赔款过账</el-button>
        <el-button
          v-if="hasPermiss('admin:exception_bill:claimBackPosting')"
          class="glo_btnItems"
          @click="claimBackPosting()"
        >赔款反过账</el-button>
        <el-button
          v-if="hasPermiss('admin:exception_bill:dutyPosting')"
          class="glo_btnItems"
          @click="detyPosting()"
        >责任核定过账</el-button>
        <el-button
          v-if="hasPermiss('admin:exception_bill:dutyBackPosting')"
          class="glo_btnItems"
          @click="dutyBackPosting()"
        >责任核定反过账</el-button>

        <el-dropdown
          class="topDropDown"
          @command="topCommandBtns"
        >
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="jtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <!-- 时间组件 -->
        <el-form-item class="queryItemsTimes">
          <multitime
            :timeType="timeType"
            :timeTypes="timeTypes"
            :startTime="startTime_a"
            :endTime="endTime_a"
            @timestatus="timestatus"
            @queryBtn_ok="queryBtn_time"
          ></multitime>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="客户单号:"
        >
          <el-input
            clearable
            v-model="queryData.customerOrderNumber"
            placeholder="请输入"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="运单号:"
        >
          <el-input
            clearable
            v-model="queryData.waybillNumber"
            placeholder="请输入"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="客户名称:"
        >
          <el-select
            clearable
            filterable
            default-first-option
            v-model="queryData.customerId"
            placeholder="请选择"
            @change="changeCustomer"
            @focus="getCustomerList()"
            remote
            :remote-method="getCustomerList"
          >
            <el-option
              v-for="(item, index) in CustomerLists"
              :key="index"
              :label="item.name"
              :value="item.documentId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="异常类型:"
        >
          <el-select
            filterable
            clearable
            v-model="queryData.billExceptionTypeId"
            placeholder="请输入"
          >
            <el-option
              v-for="item in exception_type_list"
              :key="item.exceptionTypeId"
              :label="item.typeName"
              :value="item.exceptionTypeId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="单据类型:"
        >
          <el-select
            filterable
            clearable
            v-model="queryData.documentStatus"
            placeholder="请输入"
          >
            <el-option
              v-for="item in document_Status_list"
              :key="item.statusVal"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="处理状态:"
        >
          <el-select
            filterable
            clearable
            v-model="queryData.handleStatus"
            placeholder="请输入"
          >
            <el-option
              v-for="item in handle_status_list"
              :key="item.statusVal"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          class="queryItems"
          label="发货人:"
        >
          <el-input
            clearable
            v-model="queryData.contacts"
            placeholder="请输入"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'memberNickname' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div
                class="linkTabel"
                @click.stop="goYdDetails(scope.row)"
              >{{ scope.row.memberNickname }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column
          fixed="right"
          label="操作"
          min-width="220px"
        >
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                v-if="hasPermiss('admin:exception_bill:handelException')"
                class="rbtns"
                @click.stop="WaybillEdit(scope.row)"
              >跟进</el-button>
              <el-button
                v-if="hasPermiss('admin:exception_bill:getExceptionDetail')"
                class="rbtns"
                @click.stop="goDetails(scope.row)"
              >详情</el-button>
              <el-button
                class="rbtns"
                v-if="hasPermiss('admin:exception_bill:addException')"
                @click.stop="ModifyBtns(scope.row)"
              >修改</el-button>
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="hasPermiss('admin:exception_bill:dutyException')"
                    command="a"
                  >责任核定</el-dropdown-item>
                  <el-dropdown-item
                    v-if="hasPermiss('admin:exception_bill:claimPosting')"
                    command="b"
                  >赔款过账</el-dropdown-item>
                  <el-dropdown-item
                    v-if="hasPermiss('admin:exception_bill:claimBackPosting')"
                    command="c"
                  >赔款反过账</el-dropdown-item>
                  <el-dropdown-item
                    v-if="hasPermiss('admin:exception_bill:dutyPosting')"
                    command="d"
                  >责任核定过账</el-dropdown-item>
                  <el-dropdown-item
                    v-if="hasPermiss('admin:exception_bill:dutyBackPosting')"
                    command="e"
                  >责任核定反过账</el-dropdown-item>
                  <el-dropdown-item command="f">不合格服务</el-dropdown-item>
                  <el-dropdown-item
                    v-if="hasPermiss('admin:exception_bill:completeException')"
                    command="g"
                  >完成</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 客户跟踪 -->
    <addCustomerTarck
      :showDia1="showDia1"
      :documentNumbers="documentNumbers"
      :documentStatus="documentStatus"
      :isdisabledStatus="true"
      @confirmAdd="confirmAdd"
      @closeDia1="closeDia1"
    ></addCustomerTarck>

    <!-- 弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div>
        <!-- <div class="glo_dialogForm">
          <el-form
            class="diaForm"
            v-if="isShowDialog"
            ref="dialogFormRef"
            :model="dialogForm"
            label-width="100px"
            :rules="rulesForm"
          >
            <el-form-item
              class="dialogFormItems"
              prop="waybillNumber"
              label="异常单号:"
            >
              <el-input disabled v-model="dialogForm.waybillNumber"></el-input>
            </el-form-item>
          </el-form>
        </div>-->

        <div
          class="glo_Table"
          style="margin-bottom: 20px"
        >
          <div class="h3title">
            <div class="titles">异常单号: {{ dialogForm.waybillNumber }}</div>
            <div class="iconBox">
              <el-button
                class="glo_bgcMainColor"
                @click="addIcon()"
              >添加责任人</el-button>
            </div>
          </div>

          <el-table
            :data="tableData2"
            v-if="tableData2"
            border
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop
              label="责任对象"
              width="300px"
            >
              <template slot-scope="scope">
                <div class="twoInput">
                  <!-- 结算对象类型 -->
                  <el-select
                    v-model="tableData2[scope.$index].objectStatusConfDictId"
                    placeholder="请选择"
                    @change="changeObjestStatusYS($event, scope.$index)"
                    clearable
                  >
                    <el-option
                      v-for="item in objectStatusList"
                      :key="item.confDictId"
                      :label="item.val"
                      :value="item.confDictId"
                    ></el-option>
                  </el-select>
                  <!-- 结算对象 -->
                  <el-select
                    v-model="tableData2[scope.$index].objectName"
                    clearable
                    filterable
                    allow-create
                    @change="changeobjectName1($event, scope.$index)"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in tableData2[scope.$index]
                        .CustomerListsYF"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="责任比例"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="tableData2[scope.$index].dutyRatio"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="责任金额"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="tableData2[scope.$index].amount"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="付款方式"
            >
              <template slot-scope="scope">
                <el-select
                  v-model="tableData2[scope.$index].paymentMethodConfDictId"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in settlement_methodList"
                    :key="item.confDictId"
                    :label="item.val"
                    :value="item.confDictId"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="收支类型"
            >
              <template slot-scope="scope">
                <el-select
                  v-model="tableData2[scope.$index].inoutStatus"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in inoutStatusList"
                    :key="index"
                    :label="item.name"
                    :value="item.val"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="是否生成财务单据"
            >
              <template slot-scope="scope">
                <el-select
                  v-model="tableData2[scope.$index].isFinance"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in isFinanceList"
                    :key="item.val"
                    :label="item.name"
                    :value="item.val"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="备注"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="tableData2[scope.$index].remarks"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop
              label="操作"
            >
              <template slot-scope="scope">
                <i
                  style="font-size: 30px; margin-left: 10px"
                  class="el-icon-delete"
                  @click="delIcon(scope.$index)"
                ></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </myDialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <!-- 当前页面的查询条件 -->
      <div ref="queryForm">
        <el-form
          :model="queryData"
          class="glo_form hasMoreParam"
          label-position="left"
        >
          <!-- 时间组件 -->
          <el-form-item class="queryItemsTimes">
            <multitime
              :timeType="timeType"
              :timeTypes="timeTypes"
              :startTime="startTime_a"
              :endTime="endTime_a"
              @timestatus="timestatus"
              @queryBtn_ok="queryBtn_time"
            ></multitime>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="客户单号:"
          >
            <el-input
              clearable
              v-model="queryData.customerOrderNumber"
              placeholder="请输入"
              @keyup.enter.native="queryBtn_ok"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="运单号:"
          >
            <el-input
              clearable
              v-model="queryData.waybillNumber"
              placeholder="请输入"
              @keyup.enter.native="queryBtn_ok"
            ></el-input>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="客户名称:"
          >
            <el-select
              clearable
              filterable
              default-first-option
              v-model="queryData.customerNumber"
              placeholder="请选择"
              @change="changeCustomer"
              @focus="getCustomerList()"
              remote
              :remote-method="getCustomerList"
            >
              <el-option
                v-for="(item, index) in CustomerLists"
                :key="index"
                :label="item.name"
                :value="item.number"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="异常类型:"
          >
            <el-select
              filterable
              clearable
              v-model="queryData.billExceptionTypeId"
              placeholder="请输入"
            >
              <el-option
                v-for="item in exception_type_list"
                :key="item.exceptionTypeId"
                :label="item.typeName"
                :value="item.exceptionTypeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="单据类型:"
          >
            <el-select
              filterable
              clearable
              v-model="queryData.documentStatus"
              placeholder="请输入"
            >
              <el-option
                v-for="item in document_Status_list"
                :key="item.statusVal"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="处理状态:"
          >
            <el-select
              filterable
              clearable
              v-model="queryData.handleStatus"
              placeholder="请输入"
            >
              <el-option
                v-for="item in handle_status_list"
                :key="item.statusVal"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            class="queryItems"
            label="发货人:"
          >
            <el-input
              clearable
              v-model="queryData.contacts"
              placeholder="请输入"
              @keyup.enter.native="queryBtn_ok"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </exportCompoent>
  </div>
</template>
<script>
import sorttable from '@/components/sortTemplate.vue' //自定义排序表头
import paging from '@/components/pagings.vue' //分页组件
import multitime from '@/components/multiTime.vue'
import myDialog from '@/components/Dialog.vue'
import queryBtns from '@/components/queryBtns.vue'
import addCustomerTarck from '@/components/CustomerServiceTrackingNew.vue'
import uploadimgs from '@/components/upLoadImgs.vue'
import exportjs from '@/assets/js/Mixins/export.js' //导出的公共js
export default {
  inject: ['reload'],
  mixins: [exportjs],
  components: {
    sorttable,
    paging,
    multitime,
    addCustomerTarck,
    myDialog,
    uploadimgs,
    queryBtns,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: '',
        fileName: '异常列表',
        apiName: '/admin/v3/exception/getExceptionList', //导出的数据列表接口名
        EpType: 'bdd', //dd==等待下载完成,bdd==不等待完成
        apiType: 'GET', //导出当前列表的请求方式
        pageType: 'ExceptionManage', //页面类型(主要用来区分查询参参数的时间)
      },
      //=======================导出相关 结束 =======================
      tableData2: [],
      //  -----  查询  ------
      queryData: {
        contacts: '',
        customerId: '',
        customerNumber: '',
        customerOrderNumber: '',
        documentStatus: '',
        endHappenTime: '',
        endCreateTime: '',
        exceptionTypeConfDictId: '',
        billExceptionTypeId: '',
        handleStatus: '',
        startCreateTime: '',
        startHappenTime: '',
        waybillNumber: '',
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: '0',
          label: '创建日期',
        },
        {
          value: '1',
          label: '发生日期',
        },
      ],
      timeType: '0', //  时间类型
      startTime_a: '',
      endTime_a: '',

      MoreConditions: '更多条件', //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: '75vh', //  表格高度
      selectTableData: [], //  表格选中的数据

      show_sortTableHeard: false, //显示表格设置弹窗
      // 默认表头
      tabelHeadeTitle: [
        {
          name: '月份',
          field: 'createMonth',
          width: '80',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '日期',
          field: 'takeTime',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '件数',
          field: 'totalCount',
          width: '80',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '净重',
          field: 'totalNetWeight',
          width: '80',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '收货客户',
          field: 'receiveCompany',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '交期',
          field: 'deliveryTime',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '到站',
          field: 'arrivalArea',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '异常范围',
          field: 'exceptionRange',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '异常原因',
          field: 'exceptionReason',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '责任部门/公司',
          field: 'liabilityCompany',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '信息来源',
          field: 'informationSources',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '原因分析',
          field: 'causeAnalysis',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '责任人',
          field: 'liabilityPerson',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '完成情况',
          field: 'completeSituation',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '记录人',
          field: 'recordPerson',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },


        {
          name: '异常编号',
          field: 'number',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '来源单号',
          field: 'documentNumber',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '运单号',
          field: 'waybillNumber',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '单据类型',
          field: 'documentStatusShow',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '客户名称',
          field: 'customerName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '客户编号',
          field: 'customerNumber',
          width: '140',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '客户单号',
          field: 'customerOrderNumber',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '发货人',
          field: 'contacts',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '处理状态',
          field: 'handleStatusShow',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: '异常类型',
          field: 'exceptionTypeName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '处理描述',
          field: 'handleDescribe',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: '处理时间',
          field: 'handleTime',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '申请部门',
          field: 'applyDeptName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '申请人',
          field: 'applyUserName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '完成时间',
          field: 'completeTime',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '完成人',
          field: 'completeUserName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: '创建人',
          field: 'createUserName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: '问题描述',
          field: 'describe',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: '责任核定是否已过账',
          field: 'dutyIsPostingShow',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '责任核定过账时间',
          field: 'dutyPostingTime',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '责任核定过账人',
          field: 'dutyPostingUserName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: '处理人',
          field: 'handleUserName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: '赔款金额',
          field: 'indemnityAmount',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '实际赔偿金额',
          field: 'actualIndemnityAmount',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '收款对象',
          field: 'objectName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '收款对象类型',
          field: 'objectStatus',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '外发承运商',
          field: 'outgoingCarrierName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '外发单号',
          field: 'outgoingNumber',
          width: '160',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '付款方式',
          field: 'paymentMethod',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '计划处理部门',
          field: 'planHandleDeptName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '谁跟进',
          field: 'planHandleUserName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '改善措施',
          field: 'handleProposal',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '是否已赔款过账',
          field: 'isPostingShow',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '赔款过账时间',
          field: 'postingTime',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: '赔款过账人',
          field: 'postingUserName',
          width: '110',
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        // {
        //   name: "运单号",
        //   field: "waybillNumber",
        //   width: "110",
        //   sort: 1,
        //   isShow: true, //是否展示
        //   isTotal: false, //是否开启合计
        //   isSort: true, //表格设置里面是否可以排序
        // },
      ],
      myTableHeard: [], //  我的表头
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      tableData: [], //  表格数据

      allCheck: false, //  全选
      sortName: '异常列表模板', //  排序名
      selectLength: 0, //  显示的长度

      totalArr: [], //  表格需要合计的字段
      className: '', //  导出需要
      pageGroupName: 'ExceptionManage', //  页面标识

      // 新建客服跟踪
      showDia1: false,
      documentNumbers: '',
      documentStatus: '', //包裹单据

      fileNameLists: [], //上传组件的
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: '',
      diaWidth: '80%',
      dialogForm: {
        // 弹窗表单数据
        waybillNumber: '',
        exceptionId: '',
      },
      rulesForm: {
        aaa: [
          { required: true, message: '请输入', trigger: ['blur', 'change'] },
        ],
      },
      // ==== 弹窗组件属性 end ====

      rules: {
        aaa: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
      },

      exception_type_list: [], //异常类型
      document_Status_list: [], // 单据类型
      handle_status_list: [], // 处理状态
      CustomerLists: [],
      objectStatusList: [],
      settlement_methodList: [],
      inoutStatusList: [
        {
          name: '收入',
          val: 'shou_ru:deal_status',
        },
        {
          name: '支出',
          val: 'zhi_chu:deal_status',
        },
      ],
      isFinanceList: [
        {
          name: '是',
          val: '1',
        },
        {
          name: '否',
          val: '0',
        },
      ],

      DelTableData2: [],
    }
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1
      }
      this.tabelHeadeTitle = arr
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      )
    }
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum) //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate() //今天的时间;

    this.getData()
    //获取默认表头 页面有这四个字段 myTableHeard,sortName,tabelHeadeTitle,totalArr
    this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName)
  },
  activated() {},
  mounted() {
    this.getConfDictValDownList('exception_type')
    this.getConfDictValDownList('object_status')
    this.getConfDictValDownList('settlement_method')

    this.runPageReportexception_type_choose_list();
    this.getStatusValList('bill_tms_waybill_exception_v3.document_status')
    this.getStatusValList('bill_tms_waybill_exception_v3.handle_status')
  },
  watch: {},
  methods: {
    // 新建责任对象
    addIcon(idx) {
      let datas = JSON.parse(JSON.stringify(this.tableData2)) || []
      let objs = {
        amount: '',
        dutyId: '',
        dutyRatio: '',
        inoutStatus: '',
        isFinance: '1',
        objectName: '',
        objectNumber: '',
        objectStatusConfDictId: '',
        operationType: 'ADD',
        paymentMethodConfDictId: '',
        remarks: '',
        CustomerListsYF: [],
        objectStatusType: '',
      }
      datas.push(objs)
      this.tableData2 = datas
    },
    // 删除责任对象
    delIcon(idx) {
      this.$confirm('是否删除该责任人', '提示:')
        .then(() => {
          let datas = JSON.parse(JSON.stringify(this.tableData2)) || []
          if (datas[idx].operationType !== 'ADD') {
            datas[idx].operationType = 'DEL'
            this.DelTableData2.push(datas[idx])
          }
          datas.splice(idx, 1)
          this.tableData2 = datas
        })
        .catch(() => {})
    },
    // 选择结算对象类型(应收
    changeObjestStatusYS(e, idx) {
      this.tableData2[idx].objectName = ''
      this.tableData2[idx].CustomerListsYF = []
      if (e) {
        this.objectStatusList.forEach((item) => {
          if (item.confDictId == e) {
            this.tableData2[idx].objectStatusType = item.key
          }
        })
        //
        this.getObjectUserDownListYf('', idx)
      } else {
        this.tableData2[idx].objectName = ''
        this.tableData2[idx].objectNumber = ''
        this.tableData2[idx].objectStatusConfDictId = ''
      }
    },
    changeobjectName1(e, idx) {
      if (!e) {
        this.getObjectUserDownListYf('', idx)
        this.tableData2[idx].objectNumber = ''
      } else {
        this.tableData2[idx].CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.tableData2[idx].objectNumber = item.number
          }
        })
      }
    },
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name, idx) {
      this.$API
        .wtl_getObjectUserDownList({
          key: this.tableData2[idx].objectStatusType,
          name: name || '',
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let tableData2 = JSON.parse(JSON.stringify(this.tableData2))
          tableData2[idx].CustomerListsYF = res.data.result.data || []
          this.tableData2 = tableData2
        })
    },

    // 获取客户列表
    getCustomerList(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: 'customer',
          name: name || '',
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || []
        })
    },
    getCustomerListNum(number) {},
    changeCustomer(e) {
      console.log('e', e)
    },

    runPageReportexception_type_choose_list() {
      this.$API
          .runPageReport({
            conditionReqs: [
              {
                conditonKey: '',
                conditonVal: '',
              },
            ],
            number: 'exception_type_choose_list',
            pageStart: 1,
            pageTotal: 200,
          })
          .then((res) => {
            this.exception_type_list = res.data.result.datas.data || []
          })
    },

    // 字典类型
    getConfDictValDownList(key) {
      this.$COMAPI.getConfDictValDownList(key).then((res) => {
        // if (key == 'exception_type') {
        //   //异常类型
        //   this.exception_type_list = res || []
        // }
        if (key == 'object_status') {
          // 获取结算对象类型
          this.objectStatusList = res
        }
        if (key == 'settlement_method') {
          // 付款方式
          this.settlement_methodList = res
        }
      })
    },

    // 状态下拉列表
    getStatusValList(key) {
      this.$TOOLS.getStatusValList(key).then((res) => {
        // 单据类型
        if (key == 'bill_tms_waybill_exception_v3.document_status') {
          this.document_Status_list = res || []
        }
        // 处理状态
        if (key == 'bill_tms_waybill_exception_v3.handle_status') {
          this.handle_status_list = res || []
        }
      })
    },
    // 新增
    addBtns() {
      this.$router.push({
        path: '/ExceptionManage/ExceptionAdd',
        query: {},
      })
    },
    // 修改
    ModifyBtns(row) {
      this.$router.push({
        path: '/ExceptionManage/ExceptionModify',
        query: {
          exceptionId: row.exceptionId,
        },
      })
    },
    UnqualifiedList({
      exceptionId,
      number,
      documentNumber,
      happenTime,
      customerName,
      createUserName,
      createTime,
      waybillNumber,
    }) {
      this.$router.push({
        path: '/ExceptionManage/UnqualifiedList/NewBuilt',
        query: {
          exceptions: JSON.stringify({
            exceptionId,
            number,
            documentNumber,
            customerName,
            happenTime,
            createUserName,
            createTime,
            waybillNumber,
          }),
        },
      })
    },
    // 责任核定
    ExceptionHeDing(row) {
      let exceptionId = ''
      let number = ''
      let setb = {}
      if (row.exceptionId) {
        exceptionId = row.exceptionId
        number = row.number
        setb = row
      } else {
        if (this.selectTableData.length !== 1) {
          this.$message.error('请选择 1条需要责任核定的异常单')
          return false
        }

        exceptionId = this.selectTableData[0].exceptionId
        number = this.selectTableData[0].number
        setb = this.selectTableData[0]
      }
      let { createUserName, createTime, indemnityAmount } = setb
      this.$router.push({
        path: '/ExceptionManage/ExceptionHeDing',
        query: {
          exceptionId: exceptionId,
          number: number,
          pageType: 'zrhd',
          createUserName,
          createTime,
          indemnityAmount,
        },
      })
    },
    // 过账
    claimPosting(row) {
      let ids = []
      if (row) {
        ids.push(row.exceptionId)
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error('请选择需要过账的异常单')
          return false
        }
        ids = this.selectTableData.map((item) => {
          return item.exceptionId
        })
      }
      this.$confirm('是否把所选的异常单进行 过账 操作? 请谨慎操作', '提示:')
        .then(() => {
          this.$API.wtl_claimPosting({ exceptionIds: ids }).then((res) => {
            this.$message.success(res.data.message || '操作成功')
            this.getData()
          })
        })
        .catch(() => {})
    },
    // 完成异常
    confirmBtns(row) {
      let ids = []
      if (row) {
        ids.push(row.exceptionId)
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error('请选择需要完成异常的异常单')
          return false
        }
        ids = this.selectTableData.map((item) => {
          return item.exceptionId
        })
      }
      this.$confirm('是否把所选的异常单进行 完成异常 操作? 请谨慎操作', '提示:')
        .then(() => {
          this.$API.wtl_completeException({ exceptionIds: ids }).then((res) => {
            this.$message.success(res.data.message || '操作成功')
            this.getData()
          })
        })
        .catch(() => {})
    },
    // 赔款反过账
    claimBackPosting(row) {
      let ids = []
      if (row) {
        ids.push(row.exceptionId)
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error('请选择需要赔款反过账的异常单')
          return false
        }
        ids = this.selectTableData.map((item) => {
          return item.exceptionId
        })
      }
      this.$confirm(
        '是否把所选的异常单进行 赔款反过账 操作? 请谨慎操作',
        '提示:'
      )
        .then(() => {
          this.$API.wtl_claimBackPosting({ exceptionIds: ids }).then((res) => {
            this.$message.success(res.data.message || '操作成功')
            this.getData()
          })
        })
        .catch(() => {})
    },
    // 责任核定过账
    detyPosting(row) {
      let waybillNumber = ''
      let id = ''
      if (row) {
        waybillNumber = row.waybillNumber
        id = row.exceptionId
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error('请选择一条需要核定过账的异常单')
          return false
        }
        if (this.selectTableData.length != 1) {
          this.$message.error('一次只能选一条异常单进行核定过账')
          return false
        }
        waybillNumber = this.selectTableData[0].waybillNumber
        id = this.selectTableData[0].exceptionId
      }
      this.dialogForm.waybillNumber = waybillNumber
      this.dialogForm.exceptionId = id

      this.$API.getExceptionDutyDetail({ exceptionId: id }).then((res) => {
        console.log(res, 'res')
        let datas = res.data.result.dutyVos || []
        datas.forEach((item) => {
          item.operationType = 'UPDATE'
        })
        this.tableData2 = datas

        this.isShowDialog = true
        this.dialogTitle = '责任核定过账'
      })
    },
    // 责任核定反过账
    dutyBackPosting(row) {
      let ids = []
      if (row) {
        ids.push(row.exceptionId)
      } else {
        if (this.selectTableData.length < 1) {
          this.$message.error('请选择需要责任核定反过账的异常单')
          return false
        }
        ids = this.selectTableData.map((item) => {
          return item.exceptionId
        })
      }
      this.$confirm(
        '是否把所选的异常单进行 责任核定反过账 操作? 请谨慎操作',
        '提示:'
      )
        .then(() => {
          this.$API.wtl_dutyBackPosting({ exceptionIds: ids }).then((res) => {
            this.$message.success(res.data.message || '操作成功')
            this.getData()
          })
        })
        .catch(() => {})
    },
    // 跟进
    WaybillEdit(row) {
      this.$router.push({
        path: '/ExceptionManage/ExceptionEdit',
        query: {
          exceptionId: row.exceptionId,
          number: row.number,
        },
      })
    },

    // 详情
    goDetails(row) {
      this.$router.push({
        path: '/ExceptionManage/ExceptionDetils',
        query: {
          exceptionId: row.exceptionId,
          number: row.number,
        },
      })
    },
    // 删除
    delBtns(val) {
      // 右边单选
      if (val) {
        console.log('val')
        console.log(val)
        return false
      }
      // 上面多选
      if (this.selectTableData.length < 1) {
        this.$message.error('请至少选择一条数据进行操作')
        return false
      } else {
        this.$confirm('确定要删除所选数据吗?', '提示:')
          .then((res) => {
            console.log('删除了')
          })
          .catch((err) => {})
      }
    },

    // 过账
    guoZhang() {
      this.$router.push({
        path: '/WaybillManage/Posting',
        query: {
          id: '1',
        },
      })
    },
    // 反过账
    fanGuoZhang() {},
    // 终止运单
    stopYd() {},
    // 合单
    heDan() {},

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false
      this.dialogForm.exceptionId = ''
      this.dialogForm.waybillNumber = ''
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      if (this.tableData2.length < 1) {
        this.$message.error('责任对象不能为空').showClose = true
        return false
      }

      let tableData = [...this.tableData2, ...this.DelTableData2]
      tableData.forEach((item) => {
        delete item.CustomerListsYF
        delete item.objectStatusType
      })
      // 这人核定过账
      this.$API
        .dutyPosting({
          dutyReqs: tableData || [],
          exceptionId: this.dialogForm.exceptionId,
        })
        .then((res) => {
          this.$message.success(res.data.message || '操作成功')
          this.isShowDialog = false
          this.getData()
        })
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 跳转运单详情
    goYdDetails(a) {
      // this.$message.success("你点我干嘛");
      // this.$router.push({
      //   path: "/WaybillManage/WaybillDetails",
      //   query: {
      //     yd: "123",
      //   },
      // });
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || ''
      this.endTime_a = e || ''
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || '0'
      this.startTime_a = s || ''
      this.endTime_a = e || ''
    },

    // 提交新建客服跟踪
    confirmAdd(formName) {
      this.showDia1 = false
      this.getData()
    },
    // 关闭客户跟踪弹窗,重置弹窗数据
    closeDia1(e) {
      this.showDia1 = e || false
      this.documentNumbers = '' //如果不重置这个,第二次点开同样的数据组件不会监听到变化默认是空的
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row)
    },
    rowclick2(row, event, column) {
      this.$refs.memberTable.toggleRowSelection(row)
    },

    getData() {
      let startHappenTime = ''
      let endHappenTime = ''
      let startCreateTime = ''
      let endCreateTime = ''

      let startTime = this.startTime_a ? this.startTime_a + ' 00:00:00' : ''
      let endTime = this.endTime_a ? this.endTime_a + ' 23:59:59' : ''

      if (this.timeType == '0') {
        startCreateTime = startTime
        endCreateTime = endTime
      }
      if (this.timeType == '1') {
        startHappenTime = startTime
        endHappenTime = endTime
      }

      let param = JSON.parse(JSON.stringify(this.queryData)) || ''
      param.startHappenTime = startHappenTime
      param.endHappenTime = endHappenTime
      param.startCreateTime = startCreateTime
      param.endCreateTime = endCreateTime

      param.pageStart = this.pageStart
      param.pageTotal = this.pageTotal

      this.$API.wtl_getExceptionList(param).then((res) => {
        this.className = res.data.result.className || ''
        this.tableData = res.data.result.data || []
        this.pageCount = res.data.result.pageCount || 0

        this.$nextTick(() => {
          this.fetTableHeight()
        })
      })
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1
      this.getData()
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {
        contacts: '',
        customerId: '',
        customerNumber: '',
        customerOrderNumber: '',
        documentStatus: '',
        endHappenTime: '',
        endCreateTime: '',
        exceptionTypeConfDictId: '',
        billExceptionTypeId: '',
        handleStatus: '',
        startCreateTime: '',
        startHappenTime: '',
        waybillNumber: '',
      }
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore
      if (this.isHaseMore) {
        this.MoreConditions = '收起条件'
      } else {
        this.MoreConditions = '更多条件'
      }

      this.$nextTick(() => {
        this.fetTableHeight()
      })
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val
      this.getData()
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val
      this.getData()
    },

    AddPackage() {
      //  添加包裹
      this.$router.push({
        path: '/BusinessManagement/addPacks',
      })
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e
    },
    ModifyPackage() {
      //  修改包裹
      if (this.selectTableData.length === 1) {
        this.$router.push({
          path: '/BusinessManagement/addPacks',
          query: {
            packageId: this.selectTableData[0].packageId,
          },
        })
      } else {
        this.$message.error('请选一个需要修改的包裹')
      }
    },

    PackageDetails() {
      //  包裹详情
      if (this.selectTableData.length > 0) {
        this.$router.push({
          path: '/BusinessManagement/packsDetails',
          query: {
            packageId: this.selectTableData[0].packageId,
            courierNumber: this.selectTableData[0].courierNumber,
          },
        })
      } else {
        this.$router.push({
          path: '/BusinessManagement/packsDetails',
        })
      }
    },
    dabaoDetails() {
      //  包裹详情
      if (this.selectTableData.length === 1) {
        if (
          this.selectTableData[0].packageStatus ==
            'chu_ku_zai_tu:package_status' ||
          this.selectTableData[0].packageStatus ==
            'ke_hu_qian_shou:package_status' ||
          this.selectTableData[0].packageStatus ==
            'chu_ku_zhong:package_status' ||
          this.selectTableData[0].packageStatus ==
            'da_bao_wan_cheng:package_status'
        ) {
          this.$router.push({
            path: '/BusinessManagement/dabaoDetails',
            query: {
              packageId: this.selectTableData[0].packageId,
            },
          })
        } else {
          this.$message.error('包裹未打包完成')
        }
      } else {
        this.$message.error('请选择一个包裹')
      }
    },

    // 表格合计
    getSummaries(param) {
      let that = this
      const { columns, data } = param

      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map((item) => Number(item[column.property]))
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr)
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(this.$TOOLS.add(prev, curr), 2)
                } else {
                  return prev
                }
              }, 0)
              sums[index] += ''
            } else {
              sums[index] = '---'
            }
          }
        }
      })
      this.$nextTick(() => {
        this.$refs.mytable.doLayout()
      })
      return sums
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight //页面高度
      let queryHeigth = 40 + 10 //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10 //查询框
      }
      let pagsHeigth = 40 + 20 //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60 //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || '' //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight
        this.$refs.mytable.doLayout()
      })
    },

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === 'bgsz') {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this)
      }
      if (a === 'dyyd') {
        // 打印运单
      }
      if (a === 'dybq') {
        // 打印标签
      }
      if (a === 'dr') {
        // 导入
      }
      if (a === 'jtdc') {
        // 新版导出
        this.dialogForm_dc.pageTotal = this.pageTotal
        this.isShowDialog_dc = true
      }
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: '表名(暂无效)', //表名
      })
    },

    //点击更多操作下的按钮
    handleCommandBtns(type, val) {
      console.log(type)
      console.log(val)
      // a==核定
      if (type === 'a') {
        this.ExceptionHeDing(val)
      }
      // b==赔款过账
      if (type === 'b') {
        this.claimPosting(val)
      }
      // c==赔款反过账
      if (type === 'c') {
        this.claimBackPosting(val)
      }
      // d==删除
      if (type === 'd') {
        this.delBtns(val)
      }
      // e==核定反过账
      if (type === 'e') {
        this.dutyBackPosting(val)
      }
      // e==不合格服务
      if (type === 'f') {
        this.UnqualifiedList(val)
      }
      // g== 完成
      if (type === 'g') {
        this.confirmBtns(val)
      }
    },
    // ===================排序表头彈窗的组件方法 start ===================
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false
      this.$nextTick(() => {
        this.$refs.mytable.doLayout()
      })
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e
      this.myTableHeard = this.tabelHeadeTitle
      let sortObject = this.myTableHeard
      let param = {
        groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        sortName: this.sortName, //综合查询接口路径
        sortObject: JSON.stringify(sortObject),
      }
      this.$API.pushFindFieldSort(param).then((res) => {
        this.$message.success(res.data.message || '操作成功')
        //获取默认表头
        this.$TOOLS.getGroupFindFieldSort(this, this.pageGroupName)
      })
      this.show_sortTableHeard = false //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout()
      })
      this.show_sortTableHeard = false
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this
      that.tabelHeadeTitle[idx].isShow = e
      let selectLength = 0
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++
        }
      }
      that.selectLength = selectLength
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true
      } else {
        that.allCheck = false
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this
      this.allCheck = e
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e
      }
      let selectLength = 0
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++
        }
      }
      that.selectLength = selectLength
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e
    },

    /****
     *  ===================排序表头彈窗的组件方法 end ===================
     *
     */
  },
}
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}
.twoInput {
  display: flex;
}
.h3title {
  .titles {
    font-size: 18px;
    font-weight: bold;
  }

  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f2f2f2;
  padding: 10px;
  border-bottom: 1px solid #ccc;
  font-weight: bold;
  // margin-bottom: 10px;
}
</style>
